<div class="name" (click)="onOpenDocument($event)">{{ name }}</div>
